<template>
    <iframe class="responsive-iframe" :src="homeDashboard" frameborder="0" style="border:0" allowfullscreen></iframe>
</template>

<script>
import Vue from "vue";
import { Auth, oAuth } from "../../classes/Auth";
export default Vue.extend({
  name: "Dashboard3",
  props: {
    source: String,
  },
  data: () => ({
      homeDashboard: '',
      auth: new Auth()
  }),
  mounted(){
    if(this.auth.getProject().name == 'DAVIVIENDA'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/69452da1-3f82-4960-bae6-6e90a9fbd754/page/hHWZB"
    }
    if(this.auth.getProject().name == 'DOLLARCITY'){
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/fc75e4ab-8c1c-499f-99a3-ac0d2e310c6c/page/hHWZB"
    }
    if(this.auth.getProject().name == 'MAKRO'){
      this.homeDashboard = "https://datastudio.google.com/u/0/reporting/c601dd91-132c-4add-9e7c-0f8b47bae868/page/P8g2B"
    }
  }
});
</script>

<style>
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>

